/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';
import type { ImportGroupStatus } from './ImportGroupStatus';
import {
    ImportGroupStatusFromJSON,
    ImportGroupStatusFromJSONTyped,
    ImportGroupStatusToJSON,
    ImportGroupStatusToJSONTyped,
} from './ImportGroupStatus';

/**
 * 
 * @export
 * @interface ImportGroup
 */
export interface ImportGroup {
    /**
     * 
     * @type {string}
     * @memberof ImportGroup
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportGroup
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ImportGroup
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportGroup
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportGroup
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGroup
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGroup
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof ImportGroup
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof ImportGroup
     */
    userId: string;
    /**
     * 
     * @type {ImportGroupStatus}
     * @memberof ImportGroup
     */
    status?: ImportGroupStatus;
    /**
     * 
     * @type {Array<ImportSession>}
     * @memberof ImportGroup
     */
    sessions?: Array<ImportSession> | null;
}



/**
 * Check if a given object implements the ImportGroup interface.
 */
export function instanceOfImportGroup(value: object): value is ImportGroup {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function ImportGroupFromJSON(json: any): ImportGroup {
    return ImportGroupFromJSONTyped(json, false);
}

export function ImportGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'userId': json['userId'],
        'status': json['status'] == null ? undefined : ImportGroupStatusFromJSON(json['status']),
        'sessions': json['sessions'] == null ? undefined : ((json['sessions'] as Array<any>).map(ImportSessionFromJSON)),
    };
}

export function ImportGroupToJSON(json: any): ImportGroup {
    return ImportGroupToJSONTyped(json, false);
}

export function ImportGroupToJSONTyped(value?: ImportGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'name': value['name'],
        'description': value['description'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'userId': value['userId'],
        'status': ImportGroupStatusToJSON(value['status']),
        'sessions': value['sessions'] == null ? undefined : ((value['sessions'] as Array<any>).map(ImportSessionToJSON)),
    };
}

